import { generateUUID } from '../utils';
// A new chat with its first prompt: the prompt (and any attachments) waits in
// sessionStorage under init::<chatId>, and ChatView sends it on mount. Shared
// by the composer and the Dashboard's Assist prompts (SAD-1005).
export function startChat(navigate, prompt, attachments = []) {
    // Prefix with 'shanks-' so the ID aligns with history.
    const chatId = `shanks-${generateUUID()}`;
    try {
        sessionStorage.setItem(`init::${chatId}`, JSON.stringify({
            prompt,
            attachments
        }));
    } catch (error) {
        // SessionStorage failed: the chat opens without its first message.
        console.warn('Failed to store initial prompt in sessionStorage', error);
    }
    navigate(`/assistant/${chatId}`);
    return chatId;
}
